import { VariantStockTypeEnum } from 'generated/graphql';

export interface VariantStockFields {
    StockType?: VariantStockTypeEnum | null;
    AvailableStock: number;
    AllowsBackOrder?: boolean | null;
    LeadTimeUnit?: string | null;
    CanAddToCart: boolean;
}

/**
 * Whether a variant can go in the cart at all, by the rules `useVariantStock`
 * applies to the selected one: indent and made-to-order lines are always
 * orderable, a stocked line needs stock on hand or a backorder with a lead
 * time.
 */
export const variantHasStock = (variant: VariantStockFields): boolean => {
    if (!variant.CanAddToCart) return false;
    if (
        variant.StockType === VariantStockTypeEnum.Indent ||
        variant.StockType === VariantStockTypeEnum.MadeToOrder
    ) {
        return true;
    }
    if (variant.AvailableStock > 0) return true;
    return Boolean(variant.AllowsBackOrder && variant.LeadTimeUnit);
};
